import { useTranslation } from "react-i18next";
import { Stack, Grid, Typography } from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import BoltIcon from '@mui/icons-material/Bolt';
import LightModeIcon from '@mui/icons-material/LightMode';



const SenpilicRealTimeDataVisualizer = (props) => {

    const {data, currencySymbol} = props;

    const electricityPrice = data?.electricity_price? 
        (currencySymbol === "£"?
            (data.electricity_price*100.0).toFixed(2) + " p"
        :
        data.electricity_price.toFixed(2) + " " + currencySymbol + "/kWh")
        :
        null;
    const gasPrice = data?.gas_price != null? data.gas_price.toFixed(2) + " " + currencySymbol + "/m3": "";
    const temperature = data?.temperature != null? data.temperature + " C": "";
    const consumption = data?.consumption != null ? data.consumption.toFixed(2) + " kW": null;
    const generation = data?.generation != null? data.generation.toFixed(2) + " MW": null;
    const irradiance = data?.direct_irradiance != null? data.direct_irradiance.toFixed(0) + " W/m2": null;

    const { t } = useTranslation();

    return (
        <Stack spacing={3}>
            {
                electricityPrice?
                <Grid container alignItems={"center"}>
                    <Grid item xs={1}>
                            <BoltIcon fontSize='large'/>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography component="h2" variant="h7" align="center">
                            {electricityPrice}
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="subtitle1" align="center">
                            {t("EPIAS electricity")}
                        </Typography>
                    </Grid>
                </Grid>
                :null
            }
            {
                gasPrice?
                <Grid container alignItems={"center"}>
                    <Grid item xs={1}>
                            <LocalFireDepartmentIcon fontSize='large'/>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography component="h2" variant="h7" align="center">
                            {gasPrice}
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="subtitle1" align="center">
                            {t("EPIAS gas")}
                        </Typography>
                    </Grid>
                </Grid>
                :null
            }            
            {
                consumption?
                <Grid container alignItems={"center"}>
                    <Grid item xs={1}>
                        <SpeedOutlinedIcon fontSize='large'/>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography component="h2" variant="h7" align="center">
                            {consumption}
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="subtitle1" align="center">
                            {t("Consumption")}
                        </Typography>
                    </Grid>
                </Grid>
                :
                null
            }
            {
                generation?
                <Grid container alignItems={"center"}>
                    <Grid item xs={1}>
                        <BatteryChargingFullIcon fontSize='large'/>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography component="h2" variant="h7" align="center">
                            {generation}
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="subtitle1" align="center">
                            {t("Generation")}
                        </Typography>
                    </Grid>
                </Grid>
                :
                null
            }
            {
                temperature? 
                <Grid container alignItems={"center"}>
                    <Grid item xs={1}>
                        <CloudOutlinedIcon fontSize='large'/>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography component="h2" variant="h7" align="center">
                            {temperature}
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="subtitle1" align="center">
                            {t("External temperature")}
                        </Typography>
                    </Grid>
                </Grid>
                : null
            }
            {
                irradiance? 
                <Grid container alignItems={"center"}>
                    <Grid item xs={1}>
                        <LightModeIcon fontSize='large'/>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography component="h2" variant="h7" align="center">
                            {irradiance}
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="subtitle1" align="center">
                            {t("Direct irradiance")}
                        </Typography>
                    </Grid>
                </Grid>
                : null
            }
        </Stack>
        
    );
}

export default SenpilicRealTimeDataVisualizer;